
import "../Page/Page.css";
import React, { useEffect, useState } from "react";
import useAPI from "../../Hooks/useAPI";
// import SecHeader from "../SecHeader/SecHeader";

interface VdoCipherCompProps {
  filename: string;
  constrainToParent?: boolean;
  // Only used by the titled card layout, which is commented out below.
  title?: string | false;
}

// To restore the titled card layout, add `title = false` back to the destructured props
// and swap the return block for the commented-out one below.
const VdoCipherComp: React.FC<VdoCipherCompProps> = ({ filename, constrainToParent = false }) => {
  const { getOpt } = useAPI();

  const [source, setSource] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOpt = async () => {
      try {
        const body = await getOpt(filename);

        const src = `https://player.vdocipher.com/v2/?otp=${body.otp}&playbackInfo=${body.playbackInfo}`;
        setSource(src);

        console.log("news video Response data:", body);
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
      }
    };

    fetchOpt();
  }, [filename, getOpt]);

  return (
    <div className="video-container" style={constrainToParent ? { marginTop: '5vw', marginBottom: "3vw" } : undefined}>
      <div className="image-background">
        {source && (
          <iframe
            className="OPTVideo1"
            src={source}
            allow="encrypted-media"
            allowFullScreen
            style={constrainToParent ? { width: '60vw', height: 'auto', aspectRatio: '16/9' } : undefined}
          />
        )}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );

  // Titled card layout (styles live in Page2.css under `.video-container .inv-item`).
  // return (
  //   <div className="video-container" style={constrainToParent ? { marginTop: '5vw', marginBottom: "3vw" } : undefined}>
  //     {/* {title && <SecHeader title={title} />}   */}
  //     <div className="inv-items">
  //       <div className="inv-item">
  //         <h4 className="inv-item-title">{title}</h4>
  //         <div className="image-background">
  //           {source && (
  //             <iframe
  //               className="OPTVideo1"
  //               src={source}
  //               allow="encrypted-media"
  //               allowFullScreen
  //               style={constrainToParent ? { width: '60vw', height: 'auto', aspectRatio: '16/9' } : undefined}
  //             />
  //           )}
  //           {error && <p className="error">{error}</p>}
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default VdoCipherComp;
